<template>
    <v-dialog v-model="dialog" content-class="modal-calendar-dialog">
        <v-card class="modal-calendar" v-if="showCalendar">
            <div class="common-text mb-4">
                Даты проживания гостей
            </div>
            <div class="d-flex w-100">
                <vc-calendar
                    :attributes="attributes"
                    mode="range"
                    :min-page="{ month: minMonth, year: minYear }"
                    title-position="left"
                    :locale="{ masks: { weekdays: 'WW' } }"
                    @dayclick="dayClicked"
                />
            </div>
            <v-flex v-if="endDate" class="modal-row d-flex w-100 justify-end mb-3">
                <v-btn class="btn-gradient main-text d-inline-flex" @click="$emit('editCheckIn', endDate)">
                    Заселить
                </v-btn>
            </v-flex>
            <v-flex class="modal-row d-flex w-100 justify-end">
                <v-btn class="btn-grey main-text mr-2" @click="dialog = false">
                    Закрыть
                </v-btn>
                <v-btn
                    class="btn-gradient main-text d-inline-flex"
                    :disabled="!editDate"
                    @click="$emit('editCheckIn', editDate)"
                >
                    {{ editDate && editDate.uid ? "Изменить" : "Заселить" }}
                </v-btn>
            </v-flex>
        </v-card>
    </v-dialog>
</template>

<script>
import { timeWithTZ } from '@/utils/index';

export default {
    name: "ModalCalendar",
    props: {
        value: {
            type: Boolean,
        },
        schedule: {
            type: Array,
            default: () => [],
        },
    },
    data() {
        return {
            dialog: false,
            showCalendar: false,
            attributes: [],
            minMonth: new Date().getMonth() + 1,
            minYear: new Date().getFullYear(),
            endDate: null,
            editDate: null,
            scheduleEnds: [],
            scheduleStarts: [],
        }
    },
    watch: {
        value(val) {
            if (val != this.dialog) {
                this.dialog = val;
                this.endDate = null;
                this.editDate = null;
                if (this.schedule) {
                    this.setDates();
                }
            }
        },
        dialog(val) {
            if (!val) {
                this.$emit('input', false);
                this.attributes = [];
                this.scheduleEnds = [];
                this.scheduleStarts = [];
            }
        },
    },
    methods: {
        dayClicked(day) {
            let founds = document.getElementsByClassName('vc-popover-content');
            for (let i = 0; i < founds.length; i++) {
                founds[i].style.display = 'none';
            }
            this.endDate = null;
            if (day.attributes[0]) {
                this.editDate = day.attributes[0].customData;
                let index = this.scheduleEnds.indexOf(day.id);
                if (index != -1 && day.attributes.length < 2) {
                    this.endDate = {
                        valid_after: day.id,
                        update: true,
                    };
                }
            } else if (day) {
                this.editDate = {
                    valid_after: day.id,
                    update: true,
                };
            } else {
                this.editDate = null;
            }
        },
        setDates() {
            this.attributes = [];
            this.schedule.forEach((date) => {
                this.scheduleStarts.push(date.valid_after.split(" ")[0]);
                this.scheduleEnds.push(date.valid_until.split(" ")[0]);
            });
            this.schedule.forEach((date, index) => {
                let time_after = timeWithTZ(date.valid_after);
                let time_until = timeWithTZ(date.valid_until);
                time_after = time_after.split("T");
                time_until = time_until.split("T");
                time_after = time_after[1].slice(0, 5);
                time_until = time_until[1].slice(0, 5);
                this.minMonth = new Date(date.valid_after).getMonth() + 1 < this.minMonth ?
                    new Date(date.valid_after).getMonth() + 1 : this.minMonth;
                if (new Date(date.valid_after).getFullYear() < this.minYear) {
                    this.minYear = new Date(date.valid_after).getFullYear();
                    this.minMonth = new Date(date.valid_after).getMonth() + 1;
                }
                this.attributes[index] = {
                    key: index,
                    highlight: {
                        class: `date-circle-${index % 3}`,
                    },
                    dates: {
                        start: date.valid_after, end: date.valid_until
                    },
                    popover: {
                        label: `Заселение в ${time_after}\n Выселение в ${time_until}`,
                        hideIndicator: true,
                        visibility: 'hover',
                    },
                    customData: date,
                };
            });
            this.scheduleStarts.forEach((date, index) => {
                let indexOf = this.scheduleEnds.indexOf(date);
                if (indexOf != -1) {
                    const pos = index % 3 == 0 ? 2 : (index % 3) - 1;
                    this.attributes.push({
                        highlight: {
                            class: `date-circle-${pos} date-half`,
                        },
                        dates: date,
                    });
                }
            });
            this.showCalendar = true;
        }
    }
}
</script>

<style lang="scss">
.v-dialog.modal-calendar-dialog {
    width: 340px;
}

.vc-container {
    border: none;
    width: 100%;

    .vc-pane {
        .vc-header {
            margin-bottom: 24px;

            &::after {
                content: "";
                background: #E4E5E7;
                height: 1px;
                width: 100%;
                display: block;
                position: absolute;
                top: 40px;
                left: 0;
            }

            .vc-title {
                color: #130F26;
                text-transform: capitalize;
                font-weight: 500;
                font-size: 14px;
                line-height: 17px;
            }
        }

        .vc-weeks {
            row-gap: 10px;

            .vc-weekday {
                color: #787878;
                font-weight: 400;
                font-size: 14px;
                line-height: 17px;
            }
        }
    }
}

.date-circle-0 {
    background: #EDEDED;
}

.date-circle-1 {
    background: #ffd9b3;
}

.date-circle-2 {
    background: #cde6ff;
}

.date-half {
    //clip-path: polygon(100% 0%, 100% 100%, 0% 100%);
    clip-path: polygon(0% 100%, 0% 0%, 100% 0%);
    border-radius: 0 !important;
}

.vc-popover-content.direction-bottom.vc-day-popover-container,
.vc-popover-content.direction-top.vc-day-popover-container {
    background: linear-gradient(180deg, #FFF4BC 0%, #FFE5B5 21.88%, #FFCBA8 48.96%, #FFB9A6 84.37%, #FFA5A5 100%);
    color: #130F26;
    box-shadow: 0px 4px 15px rgb(37 37 37 / 10%);
    border-radius: 64px;
    border: 1px solid rgba(0, 0, 0, 0.2);
    padding: 6px 16px;

    .vc-day-popover-header {
        display: none;
    }
}

.vc-popover-content.direction-bottom.vc-nav-popover-container,
.vc-popover-content.direction-top.vc-nav-popover-container {
    border: 1px solid rgba(0, 0, 0, 0.2);
    background: rgba(247, 247, 249, 1);
    color: #130F26;
    box-shadow: 0px 4px 15px rgb(37 37 37 / 10%);

    .vc-nav-title.vc-grid-focus {
        color: #130F26;
        background: #FFB3B3;

        &:hover,
        &:focus {
            outline: none;
            border: none;
            background: #ffcdcd;
            box-shadow: 0px 4px 15px rgb(37 37 37 / 10%);
        }
    }

    .vc-nav-item {
        color: #130F26;
        outline: none;
        border: none;

        .is-active {
            background: #FFB3B3;

            &:hover,
            &:focus {
                outline: none;
                border: none;
                background: #ffcdcd;
            }
        }
    }

    .vc-nav-item,
    .vc-nav-arrow {
        &:hover,
        &:focus {
            color: #130F26;
            outline: none;
            border: none;
            background: none;
            box-shadow: 0px 4px 15px rgb(37 37 37 / 10%);
        }
    }
}
</style>

<style lang="scss" scoped>
.modal-calendar.v-card {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    padding: 24px;
}

.btn-grey.v-btn {
    max-width: 94px;
    text-transform: none;
}

.btn-gradient.v-btn {
    width: auto;
}
</style>